/**
 * Default Widget Button Icon
 *
 * In development we use a relative path so the icon loads from the local
 * dev server (e.g. webpack serve). In production it is served from
 * CloudFront CDN. Source SVG is in public/images/default-widget-icon.svg.
 */
export const DEFAULT_WIDGET_ICON =
  process.env.NODE_ENV === 'development'
    ? '/images/default-widget-icon.svg'
    : `https://${process.env.CLOUDFRONT_DOMAIN}/images/default-widget-icon.svg`;
